module.exports = __webpack_public_path__ + "img/abbott-small.9dd487ee.png";